import axios from './AxiosInstance';

/**
 * Obtener lista de vacantes guardadas del usuario
 * GET /vacantes-guardadas
 * @returns {Promise} Lista de vacantes guardadas con paginación
 */
export const getSavedJobs = async (params = {}) => {
    try {
        const response = await axios.get('/vacantes-guardadas', { params });
        return response;
    } catch (error) {
        console.error('Error fetching saved jobs:', error);
        throw error;
    }
};

/**
 * Guardar una vacante
 * POST /vacantes/:id/guardar
 * @param {string} vacanteId - ID de la vacante
 * @returns {Promise} { saved: true }
 */
export const saveJob = async (vacanteId) => {
    try {
        const response = await axios.post(`/vacantes-guardadas/${vacanteId}`);
        return response;
    } catch (error) {
        console.error('Error saving job:', error);
        throw error;
    }
};

/**
 * Eliminar una vacante guardada
 * DELETE /vacantes/:id/guardar
 * @param {string} vacanteId - ID de la vacante
 * @returns {Promise} { saved: false }
 */
export const unsaveJob = async (vacanteId) => {
    try {
        const response = await axios.delete(`/vacantes-guardadas/${vacanteId}`);
        return response;
    } catch (error) {
        console.error('Error removing saved job:', error);
        throw error;
    }
};

export default {
    getSavedJobs,
    saveJob,
    unsaveJob,
};
